import { searchString } from "@mobsuccess-devops/react-shared/router";
import { type QueryClient } from "@tanstack/react-query";
import {
  createRootRouteWithContext,
  retainSearchParams,
} from "@tanstack/react-router";

import z from "zod";

import { RootPending } from "@/components/RootPending";

const searchSchema = z.object({
  // Carried for the other webapps: this one selects no agency or advertiser.
  account_uuid: z.string().optional(),
  client_uuid: z.string().optional(),
  // `to` is intentionally absent: PHP (auth.php) reads it off the initial
  // request into the session and owns the post-login redirect. Exposing it
  // to the router let the `/` route assign it directly, skipping the PHP hop
  // that appends the `userId`/`authId` the target needs.
  // `url_logged` is the return URL the client may follow: it has to survive
  // the navigation from the login screens back to `/`.
  url_logged: z.string().optional(),
  lang: z.string().optional(),
  // The partner platform the visitor comes from: kept so a reload of a login
  // screen still shows that partner's mark.
  source_host: z.string().optional(),
  "dashboard-data-microservice": z.string().optional(),
  id_id_app: searchString().optional(),
  store_id: searchString().optional(),
  owner_id: searchString().optional(),
});

export const Route = createRootRouteWithContext<{
  queryClient: QueryClient;
}>()({
  wrapInSuspense: true,
  pendingComponent: RootPending,
  validateSearch: searchSchema,
  search: {
    middlewares: [
      retainSearchParams([
        "client_uuid",
        "account_uuid",
        "url_logged",
        "lang",
        "source_host",
        "dashboard-data-microservice",
        "id_id_app",
        "store_id",
        "owner_id",
      ]),
    ],
  },
});
